module.exports = __webpack_public_path__ + "img/event1-compressed.d58566a9.jpg";